export default __webpack_public_path__ + "static/media/equallywed_header.1d14fca0.jpg";